const UsersConstants = {
  CHECK_IS_MFA_ACTIVATED: 'CHECK_IS_MFA_ACTIVATED',
  CHECK_IS_MFA_ACTIVATED_INIT: 'CHECK_IS_MFA_ACTIVATED_INIT',
  CHECK_IS_MFA_ACTIVATED_SUCCESS: 'CHECK_IS_MFA_ACTIVATED_SUCCESS',
  CHECK_IS_MFA_ACTIVATED_ERROR: 'CHECK_IS_MFA_ACTIVATED_ERROR',

  GET_ALL_USERS: 'GET_ALL_USERS',
  GET_ALL_USERS_INIT: 'GET_ALL_USERS_INIT',
  GET_ALL_USERS_SUCCESS: 'GET_ALL_USERS_SUCCESS',
  GET_ALL_USERS_ERROR: 'GET_ALL_USERS_ERROR',

  UPDATE_USER_STATUS: 'UPDATE_USER_STATUS',
  DELETE_USER: 'DELETE_USER',

  // Create user flow
  CREATE_USER: 'CREATE_USER',
  CREATE_USER_LOADING: 'CREATE_USER_LOADING',
  CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
  CREATE_USER_ERROR: 'CREATE_USER_ERROR',
  CLEAR_CREATE_USER_FEEDBACK: 'CLEAR_CREATE_USER_FEEDBACK',

  // Edit user flow
  EDIT_USER: 'EDIT_USER',
  EDIT_USER_LOADING: 'EDIT_USER_LOADING',
  EDIT_USER_SUCCESS: 'EDIT_USER_SUCCESS',
  EDIT_USER_ERROR: 'EDIT_USER_ERROR',
  CLEAR_EDIT_USER_FEEDBACK: 'CLEAR_EDIT_USER_FEEDBACK',

  // Fetch user details (for edit pre-population)
  GET_USER: 'GET_USER',
  GET_USER_LOADING: 'GET_USER_LOADING',
  GET_USER_SUCCESS: 'GET_USER_SUCCESS',
  GET_USER_ERROR: 'GET_USER_ERROR',
  CLEAR_GET_USER: 'CLEAR_GET_USER',
};

const RoleGroupsConstants = {
  GET_ALL_ROLE_GROUPS: 'GET_ALL_ROLE_GROUPS',
  GET_ALL_ROLE_GROUPS_INIT: 'GET_ALL_ROLE_GROUPS_INIT',
  GET_ALL_ROLE_GROUPS_SUCCESS: 'GET_ALL_ROLE_GROUPS_SUCCESS',
  GET_ALL_ROLE_GROUPS_ERROR: 'GET_ALL_ROLE_GROUPS_ERROR',
  UPDATE_ROLE_GROUP_STATUS: 'UPDATE_ROLE_GROUP_STATUS',
  DELETE_ROLE_GROUP: 'DELETE_ROLE_GROUP',

  // Create role flow
  CREATE_ROLE_GROUP: 'CREATE_ROLE_GROUP',
  CREATE_ROLE_GROUP_LOADING: 'CREATE_ROLE_GROUP_LOADING',
  CREATE_ROLE_GROUP_SUCCESS: 'CREATE_ROLE_GROUP_SUCCESS',
  CREATE_ROLE_GROUP_ERROR: 'CREATE_ROLE_GROUP_ERROR',
  CLEAR_CREATE_ROLE_GROUP_FEEDBACK: 'CLEAR_CREATE_ROLE_GROUP_FEEDBACK',

  // Edit role flow
  EDIT_ROLE_GROUP: 'EDIT_ROLE_GROUP',
  EDIT_ROLE_GROUP_LOADING: 'EDIT_ROLE_GROUP_LOADING',
  EDIT_ROLE_GROUP_SUCCESS: 'EDIT_ROLE_GROUP_SUCCESS',
  EDIT_ROLE_GROUP_ERROR: 'EDIT_ROLE_GROUP_ERROR',
  CLEAR_EDIT_ROLE_GROUP_FEEDBACK: 'CLEAR_EDIT_ROLE_GROUP_FEEDBACK',

  // Fetch role details (for edit pre-population)
  GET_ROLE_GROUP: 'GET_ROLE_GROUP',
  GET_ROLE_GROUP_LOADING: 'GET_ROLE_GROUP_LOADING',
  GET_ROLE_GROUP_SUCCESS: 'GET_ROLE_GROUP_SUCCESS',
  GET_ROLE_GROUP_ERROR: 'GET_ROLE_GROUP_ERROR',
  CLEAR_GET_ROLE_GROUP: 'CLEAR_GET_ROLE_GROUP',
};

const AllConstants = {
  UsersConstants,
  RoleGroupsConstants
}

export default AllConstants;
